'use client';

import { Radio, RadioList } from '@bytel/trilogy-react-ts';

import { FaiProduct, RangesNewGeneration } from '@app-types/fai';

type OfferRadioListProps = {
    faiProducts: FaiProduct[];
    selectedOffer?: FaiProduct | null;
    onChangeOffer: (product: FaiProduct) => void;
};

const getRadioLabel = (rangeNg: RangesNewGeneration) => {
    if (rangeNg === RangesNewGeneration.VERY_FIT) {
        return <span data-testid='label-bbox-otis'>Pure fibre</span>;
    }
    return <span data-testid='label-bbox-tv'>Fibre + TV</span>;
};
export default function OfferRadioList({ faiProducts, selectedOffer, onChangeOffer }: OfferRadioListProps) {
    return (
        <RadioList className='byou-radios network'>
            {faiProducts.map((product) => (
                <Radio
                    name='fai-offer'
                    key={product.id}
                    id={product.title}
                    label={getRadioLabel(product.range_ng)}
                    checked={product.gencode_offre === selectedOffer?.gencode_offre}
                    onChange={() => onChangeOffer(product)}
                    value={product.id.toString()}
                    horizontalTile
                    tile
                />
            ))}
        </RadioList>
    );
}
